import { Global, css } from "@emotion/react"

import { fontFamily } from "./font"

type GlobalStyleProps = {
  font?: string
  fontFamilySelector?: string
  basePath?: string
}

const GlobalStyle = ({ font = fontFamily.default, fontFamilySelector = "body", basePath = "" }: GlobalStyleProps) => {

  const fontStyle = css`
    ${fontFamilySelector} {
      font-family: ${font};
    }
  `

  const robotoFontFaces = css`
    @font-face {
      font-family: "Roboto";
      font-style: normal;
      font-weight: 400;
      font-display: swap;
      src: url("${basePath}/fonts/roboto/roboto-v50-latin-regular.woff2") format("woff2");
      unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304,
        U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
    }
    @font-face {
      font-family: "Roboto";
      font-style: normal;
      font-weight: 500;
      font-display: swap;
      src: url("${basePath}/fonts/roboto/roboto-v50-latin-500.woff2") format("woff2");
      unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304,
        U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
    }
    @font-face {
      font-family: "Roboto";
      font-style: normal;
      font-weight: 700;
      font-display: swap;
      src: url("${basePath}/fonts/roboto/roboto-v50-latin-700.woff2") format("woff2");
      unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304,
        U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
    }
  `

  return <Global styles={css(robotoFontFaces, styles.reset, fontStyle)} />
}

export default GlobalStyle

const styles = {
  reset: css`
    *,
    *::before,
    *::after {
      box-sizing: border-box;
      padding: 0;
      margin: 0;
    }
  `,
}
